export const CHAT_WS_POLICY_VIOLATION = 1008;

/**
 * Reconnect only after a socket that was actually OPEN drops (network).
 *
 * Bug this blocks: nginx 403 / FastAPI close(1008) before accept - browser
 * onclose with 1006/1008 and a retry storm (Loki: hundreds of GET /ws/chat 403).
 */
export function shouldReconnectChatWs(args: {
  userId: string;
  closeCode: number;
  everOpened: boolean;
}): boolean {
  const { userId, closeCode, everOpened } = args;
  if (!userId || userId === '0') {
    return false;
  }
  if (closeCode === CHAT_WS_POLICY_VIOLATION) {
    return false;
  }
  if (!everOpened) {
    return false;
  }
  return true;
}
